<dx-popup
  [showTitle]="true"
  titleTemplate="titleTemplate"
  [(visible)]="displayDialog"
  width="85vw"
  height="auto"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (onHidden)="closeDialog()">

  <dx-data-grid #grid
                [dataSource]="lignesBonReception"
                [height]="utils.scrollHeightContent(400)"
                [width]="'100%'"
                [showColumnLines]="true"
                columnResizingMode="widget"
                [showRowLines]="true"
                [allowColumnResizing]="true"
                [allowColumnReordering]="true"
                (onCellPrepared)="onCellPrepared($event)"
                (onRowUpdated)="onRowUpdated($event)"
                (onCellClick)="setColumnOnFocus($event)"
                [showBorders]="true">

    <!--    COLONNES-->


    <dxi-column dataField="action"
                caption="Actions"
                cellTemplate="actionCellTemplate"
                [allowEditing]="false"
                width="125">
    </dxi-column>

    <dxi-column dataField="referenceArticleFournisseur"
                caption="Réf fournisseur"
                cellTemplate="refFournisseurCellTemplate"
                [allowEditing]="false"
                width="125">
    </dxi-column>

    <dxi-column dataField="codeProduitDeclinaison"
                caption="Code denrée"
                [allowEditing]="false"
                width="125">
    </dxi-column>

    <dxi-column dataField="denominationArticle"
                [groupIndex]="0"
                caption="Dénomination"
                groupCellTemplate="denominationArticlegroupCellTemplate"
                [allowEditing]="false"
                cellTemplate="denominationArticleCellTemplate">
    </dxi-column>

    <dxi-column dataField="numeroLotInterne"
                headerCellTemplate="updateHeaderCellTemplate"
                caption="Numéro de lot interne"
                [visible]="false"
                [allowEditing]="false"
                width="200">
    </dxi-column>

    <dxi-column dataField="numeroLotFabriquant"
                headerCellTemplate="updateHeaderCellTemplate"
                [allowEditing]="!isDisabled()"
                caption="Numéro de Lot du fabriquant"
                width="200">
    </dxi-column>

    <dxi-column dataField="quantiteRecue"
                headerCellTemplate="updateHeaderCellTemplate"
                [allowEditing]="!isDisabled()"
                name="quantiteRecueUC"
                cellTemplate="quantiteRecuCellTemplate"
                caption="Qté Lot reçue en UC"
                width="120">
    </dxi-column>

    <dxi-column dataField="quantiteRecueUF"
                name="quantiteRecueUF"
                headerCellTemplate="updateHeaderCellTemplate"
                [allowEditing]="!isDisabled()"
                cellTemplate="quantiteRecuUFCellTemplate"
                caption="Qté Lot reçue en UF"
                width="120">
    </dxi-column>

    <dxi-column dataField="prixUnitaireFacture"
                headerCellTemplate="updateHeaderCellTemplate"
                cellTemplate="prixUnitaireFactureCellTemplate"
                caption="Prix Unitaire en UF"
                [allowEditing]="!isDisabled()"
                width="140">
    </dxi-column>


    <dxi-column dataField="totalFacture"
                headerCellTemplate="updateHeaderCellTemplate"
                cellTemplate="totalFactureCellTemplate"
                caption="Total HT Facturé"
                [allowEditing]="false"
                width="100">
    </dxi-column>

    <dxi-column dataField="idZds"
                headerCellTemplate="mandatoryHeaderCellTemplate"
                caption="Zone de stockage"
                [allowEditing]="!isDisabled()"
                [width]="200">
      <dxo-lookup [dataSource]="udpZdsList"
                  displayExpr="libelleZoneDeStockage"
                  valueExpr="idZoneDeStockage">
      </dxo-lookup>
    </dxi-column>

    <dxi-column dataField="dxDepartementList"
                headerCellTemplate="updateHeaderCellTemplate"
                caption="Département(s)"
                [allowEditing]="!isDisabled()"
                cellTemplate="departementCellTemplate"
                editCellTemplate="departementEditorCellTemplate"
                [visible]="bonReception?.udpHasDepartements"
                [width]="200">
    </dxi-column>

    <dxi-column dataField="dxAppellationList"
                headerCellTemplate="updateHeaderCellTemplate"

                caption="Appellation"
                [allowEditing]="!isDisabled()"
                editCellTemplate="appellationEditorCellTemplate"
                [cellTemplate]="cellTemplate"
                [width]="200">
      <dxo-lookup
        [dataSource]="appelationList"
        displayExpr="libelle"
        valueExpr="id">
      </dxo-lookup>
    </dxi-column>


    <dxi-column dataField="idOrigine"
                headerCellTemplate="updateHeaderCellTemplate"
                caption="Origine"
                [allowEditing]="!isDisabled()"
                cellTemplate="origineCellTemplate"
                [width]="200">
      <dxo-lookup [dataSource]="origineList"
                  displayExpr="libelle"
                  valueExpr="id">
      </dxo-lookup>
    </dxi-column>

    <dxi-column dataField="dxMotifNonConfoList"
                headerCellTemplate="updateHeaderCellTemplate"
                caption="Motifs de non conformité"
                [cellTemplate]="cellTemplate"
                editCellTemplate="motifNonConfoEditorCellTemplate"
                [allowEditing]="!isDisabled()"
                [width]="200">
      <dxo-lookup
        [dataSource]="motifNonConformiteList"
        displayExpr="libelle"
        valueExpr="id">
      </dxo-lookup>
    </dxi-column>

    <dxi-column dataField="dxLitigeList"
                headerCellTemplate="updateHeaderCellTemplate"
                caption="Litiges"
                [cellTemplate]="cellTemplate"
                editCellTemplate="litigeEditorCellTemplate"
                [allowEditing]="!isDisabled()"
                [width]="200">
      <dxo-lookup
        [dataSource]="litigeList"
        displayExpr="libelle"
        valueExpr="id">
      </dxo-lookup>
    </dxi-column>

    <dxi-column dataField="dlc"
                headerCellTemplate="updateHeaderCellTemplate"
                caption="DLC"
                [allowEditing]="!isDisabled()"
                width="100">
    </dxi-column>

    <dxi-column dataField="temperatureCelsius"
                headerCellTemplate="updateHeaderCellTemplate"
                dataType="number"
                caption="Temperature"
                [allowEditing]="!isDisabled()"
                width="100">
    </dxi-column>

    <dxi-column dataField="remarque"
                caption="Remarque"
                [allowEditing]="!isDisabled()"
                width="500">
    </dxi-column>

    <dxi-column dataField="lotManuel"
                sortOrder="asc"
                [visible]="false"
                [allowHiding]="true"
                [allowEditing]="false"
                width="50"
                caption="Lot additionel">
    </dxi-column>

    <!--  OPTION TABLE-->
    <dxo-editing mode="cell" [allowUpdating]="true" [confirmDelete]="false"></dxo-editing>
    <dxo-column-chooser mode="select" [enabled]="true"></dxo-column-chooser>
    <dxo-grouping #expand [allowCollapsing]="false" [autoExpandAll]="true"></dxo-grouping>

    <!-- TEMPLATE HEADER-->
    <div *dxTemplate="let cell of 'mandatoryHeaderCellTemplate'">
      <div [title]="'Colonne obligatoire : ' + cell.column.caption">
        {{ cell.column.caption }}
      </div>
    </div>

    <div *dxTemplate="let cell of 'updateHeaderCellTemplate'">
      <div [title]="'Colonne modifiable : ' + cell.column.caption">
        {{ cell.column.caption }}
      </div>
    </div>
    <!-- TEMPLATE COLONNE-->

    <div *dxTemplate="let cell of 'actionCellTemplate'" class="custom-button-container-left">
      @if (isAddButtonAvailable(cell.row.data)) {
        <yo-button
          iconClass="fas fa-plus"
          size="small"
          [theme]="ButtonThemeEnum.SECONDARY_INNER"
          (onClick)="addLotArticle(cell.row.data)"
          tooltip="Ajouter un lot pour cet article"
          [disabled]="isDisabled()">
        </yo-button>
      }
      @if (isDeleteButtonAvailable(cell.row.data)) {
        <yo-button
          iconClass="fas fa-times"
          size="small"
          [theme]="ButtonThemeEnum.DELETE_INNER"
          (onClick)="bonReceptionLigneSvc.deleteLotArticle(cell.row.data)"
          tooltip="Supprimer ce lot"
          [disabled]="isDisabled()">
        </yo-button>
      }
      @if (isImageButtonAvailable(cell.row.data)) {
        <yo-button
          iconClass="fas fa-camera"
          size="small"
          [theme]="ButtonThemeEnum.SECONDARY_INNER"
          (onClick)="openImageDialog(cell.row.data)"
          [tooltip]="this.canEdit() ? 'Ajouter une ou plusieurs photos' : 'Consulter la ou les photos'"
          [label]="getImageCount(cell.row.data)">
        </yo-button>
      }
    </div>



    <div *dxTemplate="let cell of 'denominationArticleCellTemplate'"
         [class.justify-content-start]="!cell.row.data.lotManuel"
         [class.justify-content-end]="cell.row.data.lotManuel"
         class="d-flex align-items-center">

      @if (cell.row.data.ratioUniteDeStockageUniteBase === 0 && !cell.row.data.lotManuel) {
        <span>
          <i class="fas fa-exclamation-triangle danger-color space"
             title="Le ratio d'unité de stockage de cet article est égal à 0">
          </i>
        </span>
      }

      {{ !cell.row.data.lotManuel ? cell.row.data.denominationArticle : '' }}
    </div>

    <div *dxTemplate="let cell of 'denominationArticlegroupCellTemplate'">

      <!--      DENOMINATION-->
      <div class="d-flex flex-row justify-content-between align-items-center">
        <div class="d-flex flex-row align-items-center">
      <span class="fa-stack mg-r-10" [title]="getTooltipIcon(cell.data.items[0]?.receptionStatutCode)">
            <i class="far fa-square fa-stack-2x"
               [class.color-nouveau]="cell.data.items[0]?.receptionStatutCode === receptionStatutCode.NOUVEAU"
               [class.color-en-cours]="cell.data.items[0]?.receptionStatutCode === receptionStatutCode.EN_COURS"
               [class.color-partiel]="cell.data.items[0]?.receptionStatutCode === receptionStatutCode.RECEPTION_PARTIELLE"
               [class.color-termine]="cell.data.items[0]?.receptionStatutCode === receptionStatutCode.TERMINE"></i>
            @if (cell.data.items[0]?.receptionStatutCode === receptionStatutCode.NOUVEAU) {
              <strong class="fa-stack-1x color-nouveau">N</strong>
            }
            @if (cell.data.items[0]?.receptionStatutCode === receptionStatutCode.EN_COURS) {
              <strong class="fa-stack-1x color-en-cours">E</strong>
            }
            @if (cell.data.items[0]?.receptionStatutCode === receptionStatutCode.RECEPTION_PARTIELLE) {
              <strong class="fa-stack-1x color-partiel">R</strong>
            }
            @if (cell.data.items[0]?.receptionStatutCode === receptionStatutCode.TERMINE) {
              <strong class="fa-stack-1x color-termine">T</strong>
            }
      </span>
          <p>{{ cell.value }}</p>
          <span class="mg-l-5">
            @if (cell.row.data.items[0]?.ratioUniteDeStockageUniteBase === 0) {
              <i class="fas fa-exclamation-triangle danger-color space"
                 title="Le ratio d'unité de stockage de cet article est égal à 0">
              </i>
            }
           </span>
          <span class="mg-l-5">
          <yo-info-lotmarche-article [uniteDeProductionId]="cell.row.data.items[0]?.idUniteDeProduction"
                                     [lotMarchePdLumpCa]="cell.row.data.items[0]?.lmPdUpCa"></yo-info-lotmarche-article>
          </span>
          <div>

            @if (cell.data.items[0]?.produitCarne) {
              <label (click)="openDialogProduitCarne($event, cell.row.data.items)"
                     title="Informations supplémentaires pour les produits carnés"
                     class="badge mg-l-5 cursor badge-danger">

                <div class="i-size">V</div>
              </label>
            }
          </div>
        </div>

        <!--        QUANTITE-->
        <div class="d-flex flex-row align-items-center">
          <div class="d-flex flex-row  align-items-center mg-r-10">
            <p class="mg-r-5"> Qté Commandée : </p>
            <span class="mg-r-5">
              {{ cell.data.items[0]?.quantiteCommandee }}
            </span>
            <span class="mg-r-5">
              {{ cell.data.items[0]?.uniteDeCommande }}
            </span>
          </div>

          <div class="d-flex flex-row align-items-center mg-r-10">
            <p class="mg-r-5"> Qté déjà réceptionnée : </p>
            <span class="mg-r-5">
              {{ cell.data.items[0]?.quantiteDejaReceptionnee }}
            </span>
            <span class="mg-r-5">
              {{ cell.data.items[0]?.uniteDeCommande }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div *dxTemplate="let cell of 'origineCellTemplate'"
         class="d-flex justify-content-center align-items-center">
      {{ cell.row.data.origine?.libelle }}
    </div>

    <div *dxTemplate="let cell of 'departementCellTemplate'">
      {{ getDepartementNoms(cell.value) }}
    </div>

    <div *dxTemplate="let item of 'origineEditCellTemplate'">
    </div>

    <div *dxTemplate="let cell of 'quantiteRecuCellTemplate'"
         class="d-flex justify-content-center align-items-center">
      <span class=" mg-r-5">{{ cell?.value }}</span>
      <span [title]="cell.row.data.uniteDeCommande">{{ cell.row.data.uniteDeCommandeAbreviation }}</span>
    </div>

    <div *dxTemplate="let cell of 'quantiteRecuUFCellTemplate'"
         class="d-flex justify-content-center align-items-center">
      <span class=" mg-r-5">{{ cell.value }}</span>
      <span [title]="cell.row.data.uniteDeFacturation">{{ cell.row.data.uniteDeFacturationAbreviation }}</span>
    </div>

    <div *dxTemplate="let cell of 'refFournisseurCellTemplate'">
      <span>{{ cell?.value }}</span>
    </div>

    <div *dxTemplate="let cell of 'prixUnitaireFactureCellTemplate'">
      <span>{{ cell?.value | currency:'EUR':'symbol':'1.4-4' }}</span>/<span
      [title]="cell.row.data.uniteDeFacturation">{{ cell.row.data.uniteDeFacturationAbreviation }}</span>
    </div>

    <div *dxTemplate="let cell of 'totalFactureCellTemplate'">
      <span>{{ cell?.value | currency:'EUR':'symbol':'1.4-4' }}</span>
    </div>

    <div *dxTemplate="let cell of 'dlcCellTemplate'">
      <p-calendar
        appendTo="body"
        [locale]="fr"
        firstDayOfWeek="1"

        showButtonBar="true"
        class="vertical-align"
        [(ngModel)]="cell.value"
        dateFormat="dd/mm/yy"
        readonlyInput="true"
        [showWeek]="true"
        [style]="{'width':'100%'}"
        [inputStyle]="{'width':'100%'}"
        [disabled]="isDisabled()">
      </p-calendar>
    </div>

    <div *dxTemplate="let cell of 'prixUnitaireFactureTemplate'"
         class="d-flex justify-content-center align-items-center">

      <span class=" mg-r-5">{{ cell.value }}</span>
      <div class="input-group-append" [title]="cell.row.data.uniteDeFacturation">€
        /  {{ cell.row.data.uniteDeFacturationAbreviation }}
      </div>
    </div>

    <div *dxTemplate="let cellInfo of 'departementEditorCellTemplate'">
      <yo-multiselect
        [data]="departementListEnriched"
        displayValue="nom"
        [expandedGroups]="false"
        [groupFn]="groupDepartementByRegion"
        [selectedItems]="getDepartementIdsFromList(cellInfo.value)"
        [searchExpr]="['nom', 'code', 'regionNom', 'regionCode']"
        placeholder="Sélectionner des départements"
        (onValueChange)="setDepartementsFromIds(cellInfo, $event)">
      </yo-multiselect>
    </div>

    <div *dxTemplate="let cellInfo of 'appellationEditorCellTemplate'">
      <yo-multiselect
        [data]="appelationList"
        [selectedItems]="getAppellationIdsFromList(cellInfo.value)"
        displayValue="libelle"
        (onValueChange)="setAppellationsFromIds(cellInfo, $event)">
      </yo-multiselect>
    </div>

    <div *dxTemplate="let cellInfo of 'motifNonConfoEditorCellTemplate'">
      <yo-tagbox
        [data]="motifNonConformiteList"
        [selectedItems]="cellInfo.data.dxMotifNonConfoIdList"
        [displayValue]="'libelle'"
        [maxDisplayedTags]="5"
        [dropDownOptions]="{ wrapperAttr: { class: 'yo-tagbox-dropdown' } }"
        (onValueChange)="onMotifNonConfChange(cellInfo, $event)">
      </yo-tagbox>
    </div>

    <div *dxTemplate="let cellInfo of 'litigeEditorCellTemplate'">
      <yo-tagbox
        [data]="litigeList"
        [selectedItems]="cellInfo.value"
        [displayValue]="'libelle'"
        [maxDisplayedTags]="5"
        [dropDownOptions]="{ wrapperAttr: { class: 'yo-tagbox-dropdown' } }"
        (onValueChange)="cellInfo.setValue($event)">
      </yo-tagbox>
    </div>

  </dx-data-grid>

  <yo-legend-grid-dev-extreme
    [modificationManuelle]="false"
    [colonneModifiable]="true"
    [colonneInformations]="false"
    [colonneObligatoire]="true">
  </yo-legend-grid-dev-extreme>

  <!--TEMPLATE HEADER DIALOG-->
  <div class="title" *dxTemplate="let data of 'titleTemplate'">
    @if (bonReception) {
      <span class="mg-r-5">
        <yo-statuts-reception [bonReception]="bonReception" [longLabel]="true"></yo-statuts-reception>
      </span>

      @if (invoiceLinked) {
        <span class="mg-r-5 available-invoice">
          Associé à la facture
          @if (invoiceLinked.number) {
            <ng-container> n°{{ invoiceLinked.number }}</ng-container>
          }
        </span>
      }

      <span class="mg-r-5">
        - Bon de réception {{ bonReception?.numeroBonReception }}
      </span>

      <span class="mg-r-5">
       - Le  {{ bonReception.dateLivraison | date:'dd/MM/yyyy HH:mm' | titlecase }}
      </span>

      <span class="mg-r-5">
       -  {{ bonReception.libelleUniteDeProduction }}
      </span>

      @if (!utils.isNullOrEmpty(bonReception.numeroBonLivraison)) {
        <span class="mg-r-5">
         - Numéro de livraison {{ bonReception.numeroBonLivraison }}
        </span>
      }
      <span class="close-btn">
      <i class="fa-solid fa-xmark fa-xl" (click)="closeDialog()"></i>
        </span>
    }
  </div>
  <div class="reception-data-div">
    @if (lignesBonReception && lignesBonReception.length > 0) {
      <div class="reception-data">
      <div class="m-0 dx-field">
        <div class="dx-field-label">
          <strong>Frais de Port</strong>
        </div>
        <div class="dx-field-value">
          <dx-number-box [class]="isDisabled() ? 'border-0' : ''" format="#0.###0 €"
                         [value]="bonReception.francoDePortCout" [step]="0.0001"
                         (onValueChanged)="updateFrancoPort($event)"
          ></dx-number-box>
        </div>
      </div>
      <div class="m-0 dx-field">
        <div class="dx-field-label">
          <strong>Montant HT</strong>
        </div>
        <div class="dx-field-value">
          <dx-number-box class="border-0" format="#0.###0 €" [value]="bonReception.montantTotalHT"
                         [readOnly]="true"></dx-number-box>
        </div>
      </div>
      <div class="m-0 dx-field">
        <div class="dx-field-label">
          <strong>TVA</strong>
        </div>
        <div class="dx-field-value">
          <dx-number-box class="border-0" format="#0.###0 €"
                         [value]="(bonReception.montantTotalTTC - bonReception.montantTotalHT - bonReception.francoDePortCout)"
                         [readOnly]="true"></dx-number-box>
        </div>
      </div>
      <div class="m-0 dx-field">
        <div class="dx-field-label">
          <strong>Montant TTC</strong>
        </div>
        <div class="dx-field-value">
          <dx-number-box class="border-0" format="#0.###0 €" [value]="bonReception.montantTotalTTC"
                         [readOnly]="true"></dx-number-box>
        </div>
      </div>
    </div>
    }
  </div>

  <div class="dialog-line">
    <div class="custom-button-container-right">
      @if (hasCommandesFacturesRight && invoiceLinked) {
        <yo-button
          [theme]="ButtonThemeEnum.DEFAULT"
          iconClass="fas fa-file-invoice-dollar"
          (onClick)="goToFacture(invoiceLinked.id)"
          label="Ouvrir la facture">
        </yo-button>
      }
      @if (isAbleToBindBill()) {
        <span>
       <yo-button
         [theme]="ButtonThemeEnum.DEFAULT"
         iconClass="fas fa-dollar-sign"
         (onClick)="enableDialogBindBill()"
         label="Lier une facture">
       </yo-button>
     </span>
      }
      <yo-button
        [theme]="ButtonThemeEnum.DEFAULT"
        iconClass="fas fa-print"
        (onClick)="bonReceptionSvc.getPDFBonReception(bonReception)"
        label="Imprimer">
      </yo-button>
      <yo-button
        #reception
        id="reception"
        [theme]="ButtonThemeEnum.SAVE"
        iconClass="fas fa-save"
        label="Réception"
        [disabled]="isDisabled()"
      >
      </yo-button>
      <dx-context-menu
        [elementAttr]="{ class: 'custom-context-menu-reception' }"
        [items]="itemsReceptions"
        target="#reception"
        (onItemClick)="itemClick($event)"
        [showEvent]="{ name: 'dxclick', delay: 0 }"
      >
      </dx-context-menu>
      <yo-button
        [theme]="ButtonThemeEnum.DELETE_INNER"
        iconClass="fas fa-times"
        (onClick)="closeDialog()"
        label="Fermer">
      </yo-button>
    </div>
  </div>
</dx-popup>


<yo-origine-carne
  #dialogOrigineCarne
  [origines]="origineList"
  (onValueChange)="updateOrigines($event)"
  [disabled]="isDisabled()"
>
</yo-origine-carne>

<dx-popup
  [showTitle]="true"
  title="Lier le bon de réception à une facture"
  [dragEnabled]="true"
  [closeOnOutsideClick]="true"
  [showCloseButton]="true"
  [(visible)]="openDialogBindBill"
  (onHiding)="closeDialogBindBill()"
  [width]="600"
  [height]="'auto'"
>
  @if (numbersBills.length === 1) {
    <label for="numBill">Pour générer une facture, saisissez le
      numéro de facture fourni par votre fournisseur : </label>
  }
  @if (numbersBills.length > 1) {
    <label for="numBill">Pour générer une facture, sélectionnez un
      numéro de facture existant ou créer un nouveau numéro de facture avec le numéro fourni par votre fournisseur
      : </label>
  }

  <div class="dialog-line">
    <div class="label">Numéro de facture</div>
    <div class="value">
      @if (numbersBills.length === 1) {
        <dx-text-box
                     [(ngModel)]="numBill"
                     id="numBill"
                     placeholder="Numéro de facture">
        </dx-text-box>
      }
      @if (numbersBills.length > 1) {
        <dx-lookup
                   [value]="numBill"
                   [items]="numbersBills"
                   (onValueChanged)="onChangeNumBill($event)"
                   placeholder="Sélection/Création d'un numéro de facture (existant)">
        </dx-lookup>
      }
    </div>
  </div>

  <div class="dialog-line">
    <div class="label">Numéro de bon de livraison</div>
    <div class="value">
      <dx-text-box
        [(ngModel)]="numBonLivraison"
        placeholder="Numéro de bon de livraison">
      </dx-text-box>
    </div>
  </div>

  <div class="dialog-line">
    <div class="label">Date de facture</div>
    <div class="value">
      <dx-calendar
        #calendar
        [(ngModel)]="selectedDate"
        [firstDayOfWeek]="0">
      </dx-calendar>
    </div>
  </div>

  <div class="custom-button-container-right mg-t-10">
    <yo-button
      [theme]="ButtonThemeEnum.SAVE"
      iconClass="fas fa-save"
      label="Enregistrer"
      (onClick)="bindBonReceptionToBill()">
    </yo-button>
    <yo-button
      [theme]="ButtonThemeEnum.SAVE"
      iconClass="fas fa-save"
      label="Enregistrer et ouvrir la facture"
      (onClick)="bindBonReceptionToBillAndNavigate()">
    </yo-button>
  </div>
</dx-popup>

<yo-image-list-popup
  [isOpened]="isImagePopupOpened"
  (onClose)="onImagePopupClose($event)"
  [values]="images"
  [disabled]="!canEdit()"
></yo-image-list-popup>
